import { Icon, IconName } from "@blueprintjs/core";

import { Tooltip } from "@/components/helpers/ui/blueprint-overrides/Tooltip";
import { SUBTEXT_COLOR } from "@/css/constants";
import { VisibilityScope } from "@/graphql";

const scopeIconMap: Record<
  VisibilityScope,
  { icon: IconName; content: string }
> = {
  [VisibilityScope.Global]: { icon: "globe", content: "Global" },
  [VisibilityScope.User]: { icon: "person", content: "User" },
  [VisibilityScope.Workspace]: { icon: "office", content: "Workspace" },
};

export function RoleplayScopeIcon({ scope }: { scope: VisibilityScope }) {
  const { icon, content } = scopeIconMap[scope] || {};

  if (!icon || !content) return null;

  return (
    <Tooltip content={content}>
      <Icon icon={icon} color={SUBTEXT_COLOR} />
    </Tooltip>
  );
}
